import * as React from 'react'
import { useEffect } from 'react'

import { Box, Icon, Title, WizardStepRenderParams } from '@factorialco/deprecated-design-system'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import { acceptedContentTypes } from 'modules/core/lib/fileFormats'
import i18n from 'modules/core/lib/i18n'

import DropzoneBox from 'modules/documents/components/Documents/DropzoneBox'
import FileList from 'modules/documents/components/FileList'
import type { WizardData } from 'modules/procurement/components/purchaseRequests/NewRequestModal/types'

interface Props {}

const AttachmentsStep: React.FC<WizardStepRenderParams<WizardData> & Props> = ({
  data,
  onDataChanged,
}) => {
  const ACCEPTED_CONTENT_TYPES = acceptedContentTypes([
    'image/gif',
    'image/jpeg',
    'image/png',
    'application/pdf',
  ])
  const onDrop = (files: File[]) => onDataChanged({ ...data, files: data.files.concat(files) })

  const onRemoveFile = (indexToRemove: number) =>
    onDataChanged({ ...data, files: data.files.filter((_file, index) => index !== indexToRemove) })

  useEffect(() => {
    track(trackingEvents.procurement.goToAttachmentsStepOnNewPurchaseRequestWizard)
  }, [])

  return (
    <Box gap="s24">
      <Title
        description={i18n.t(
          'procurement.purchase_requests.new_request_wizard.steps.attachments.description'
        )}
        title={i18n.t('procurement.purchase_requests.new_request_wizard.steps.attachments.title')}
      />
      <Box gap="s12" paddingRight="s24">
        <DropzoneBox
          onDrop={onDrop}
          iconName="file-upload"
          multiple
          message={i18n.t(
            'procurement.purchase_requests.new_request_wizard.steps.attachments.dropzone.title'
          )}
          description={i18n.t(
            'procurement.purchase_requests.new_request_wizard.steps.attachments.dropzone.description'
          )}
          accept={ACCEPTED_CONTENT_TYPES}
        />

        {!!data.files && (
          <FileList
            files={data.files}
            renderIcon={() => (
              <Box maxHeight="s32" paddingY="s2">
                <Icon.Large icon="file-approved" />
              </Box>
            )}
            onDeleteFile={onRemoveFile}
          />
        )}
      </Box>
    </Box>
  )
}

export default AttachmentsStep
